"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_2 = require("react");
var react_hook_form_1 = require("react-hook-form");
var dayjs_1 = __importDefault(require("dayjs"));
var recoil_1 = require("recoil");
var utc_1 = __importDefault(require("dayjs/plugin/utc"));
var react_router_dom_1 = require("react-router-dom");
var components_1 = require("@/components");
var Styled = __importStar(require("./ApplicationPanel.styled"));
var Button_component_1 = require("@/components/common/Button/Button.component");
var __1 = require("..");
var ApplicationStatusBadge_component_1 = __importStar(require("@/components/common/ApplicationStatusBadge/ApplicationStatusBadge.component"));
var date_1 = require("@/utils/date");
var Select_component_1 = require("@/components/common/Select/Select.component");
var hooks_1 = require("@/hooks");
var utils_1 = require("@/utils");
var api = __importStar(require("@/api"));
var types_1 = require("@/types");
var store_1 = require("@/store");
var styles_1 = require("@/styles");
dayjs_1.default.extend(utc_1.default);
var ControlArea = function (_a) {
    var confirmationStatus = _a.confirmationStatus, resultStatus = _a.resultStatus, interviewDate = _a.interviewDate, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b;
    var _c = (0, react_hook_form_1.useFormContext)(), setValue = _c.setValue, getValues = _c.getValues, watch = _c.watch, register = _c.register;
    var date = getValues('interviewStartedAt');
    var isEdit = watch('isEdit');
    var isInterviewConfirmed = (0, react_2.useMemo)(function () {
        return [
            'INTERVIEW_CONFIRM_ACCEPTED',
            'INTERVIEW_CONFIRM_REJECTED',
            'FINAL_CONFIRM_WAITING',
            'FINAL_CONFIRM_ACCEPTED',
            'FINAL_CONFIRM_REJECTED',
        ].some(function (each) { return each === confirmationStatus; });
    }, [confirmationStatus]);
    var isScreeningPassed = (0, react_2.useMemo)(function () {
        return [
            'SCREENING_PASSED',
            'INTERVIEW_TO_BE_DETERMINED',
            'INTERVIEW_FAILED',
            'INTERVIEW_PASSED',
        ].some(function (each) { return each === resultStatus; });
    }, [resultStatus]);
    var _d = __read((0, react_2.useState)(resultStatus === types_1.ApplicationResultStatusInDto.SCREENING_PASSED), 2), isShowInterviewSchedule = _d[0], setIsShowInterviewSchedule = _d[1];
    var _e = __read((0, react_2.useState)(false), 2), isDatePickerOpened = _e[0], setIsDatePickerOpened = _e[1];
    var outerRef = (0, react_2.useRef)(null);
    var selectedApplicationResultStatusRef = (0, react_2.useRef)(null);
    var selectedInterviewStartedAtRef = (0, react_2.useRef)(null);
    var handleSelectDate = (0, react_2.useCallback)(function (clickedDate) {
        var currentDate = (0, dayjs_1.default)(date);
        setValue("interviewStartedAt", (0, dayjs_1.default)(clickedDate).hour(currentDate.hour()).minute(currentDate.minute()).second(0).format());
        setIsDatePickerOpened(false);
    }, [date, setValue]);
    var handleToggleIsEdit = (0, react_2.useCallback)(function () {
        setValue('isEdit', !isEdit);
    }, [isEdit, setValue]);
    var handleToggleDatePicker = function () {
        setIsDatePickerOpened(function (prev) { return !prev; });
    };
    var handleChangeApplicationResultSelect = (0, react_2.useCallback)(function (option) {
        setValue("applicationResultStatus", option.value);
        if (option.value === types_1.ApplicationResultStatusInDto.SCREENING_PASSED) {
            setIsShowInterviewSchedule(true);
        }
        else {
            setIsShowInterviewSchedule(false);
        }
    }, [setValue]);
    var handleChangeTimeSelect = (0, react_2.useCallback)(function (option) {
        setValue("interviewStartedAt", option.value);
    }, [setValue]);
    (0, hooks_1.useOnClickOutSide)(outerRef, function () { return setIsDatePickerOpened(false); });
    var applicationResultOptions = (0, react_2.useMemo)(function () {
        var resultOption = Object.values(ApplicationStatusBadge_component_1.ApplicationResultStatus).reduce(function (acc, cur, index) { return __spreadArray(__spreadArray([], __read(acc), false), [
            { value: Object.keys(ApplicationStatusBadge_component_1.ApplicationResultStatus)[index], label: cur },
        ], false); }, []);
        if (isScreeningPassed) {
            return resultOption.slice(1, resultOption.length);
        }
        return resultOption.slice(0, 4);
    }, [isScreeningPassed]);
    var timeOptions = (0, react_2.useMemo)(function () {
        return (0, utils_1.rangeArray)(14 * 6 + 1).reduce(function (acc, cur) {
            var min = (cur % 6) - 1;
            var hour = Math.floor(cur / 6);
            var d = (0, dayjs_1.default)(date)
                .clone()
                .hour(8 + hour)
                .minute(min * 10)
                .second(0)
                .format();
            return __spreadArray(__spreadArray([], __read(acc), false), [{ value: d, label: (0, date_1.formatDate)(d, 'a hh시 mm분') }], false);
        }, []);
    }, [date]);
    if (isEdit) {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(__1.TitleWithContent, __assign({ title: "\uD569\uACA9 \uC5EC\uBD80", isActive: true }, { children: (0, jsx_runtime_1.jsx)(components_1.Select, { size: Select_component_1.SelectSize.md, options: applicationResultOptions, isFullWidth: true, ref: selectedApplicationResultStatusRef, onChangeOption: handleChangeApplicationResultSelect, defaultValue: applicationResultOptions.find(function (option) { return option.value === resultStatus; }) }, void 0) }), void 0), isShowInterviewSchedule && ((0, jsx_runtime_1.jsx)(__1.TitleWithContent, __assign({ title: "\uBA74\uC811 \uC77C\uC2DC", isActive: !isInterviewConfirmed }, { children: (0, jsx_runtime_1.jsxs)(Styled.SelectContainer, __assign({ disabled: isInterviewConfirmed }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ ref: outerRef }, { children: [(0, jsx_runtime_1.jsx)(Styled.SelectWrapper, __assign({ onClick: handleToggleDatePicker, isDatePickerOpened: isDatePickerOpened }, { children: (0, date_1.formatDate)(date, 'YYYY년 M월 D일(ddd)') }), void 0), (0, jsx_runtime_1.jsx)(Styled.SelectMenu, __assign({ isDatePickerOpened: isDatePickerOpened }, { children: (0, jsx_runtime_1.jsx)(components_1.DatePicker, { handleSelectDate: handleSelectDate, selectedDate: (0, dayjs_1.default)(date) }, void 0) }), void 0)] }), void 0), (0, jsx_runtime_1.jsx)(Styled.SelectTimeField, { children: (0, jsx_runtime_1.jsx)(components_1.Select, __assign({ size: Select_component_1.SelectSize.md, options: timeOptions, isFullWidth: true, onChangeOption: handleChangeTimeSelect, disabled: isInterviewConfirmed, defaultValue: timeOptions.find(function (option) { return option.value === (0, dayjs_1.default)(date).format(); }) }, register("interviewStartedAt", { required: true }), { ref: selectedInterviewStartedAtRef }), void 0) }, void 0)] }), void 0) }), void 0)), (0, jsx_runtime_1.jsxs)(Styled.ButtonContainer, { children: [(0, jsx_runtime_1.jsx)(components_1.Button, { "$size": Button_component_1.ButtonSize.sm, shape: Button_component_1.ButtonShape.defaultLine, label: "\uCDE8\uC18C", onClick: handleToggleIsEdit }, void 0), (0, jsx_runtime_1.jsx)(components_1.Button, { type: "submit", "$size": Button_component_1.ButtonSize.sm, shape: Button_component_1.ButtonShape.primary, label: "\uC800\uC7A5", isLoading: isLoading }, void 0)] }, void 0)] }, void 0));
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(__1.TitleWithContent, __assign({ title: "\uD569\uACA9 \uC5EC\uBD80" }, { children: (0, jsx_runtime_1.jsx)(ApplicationStatusBadge_component_1.default, { text: ApplicationStatusBadge_component_1.ApplicationResultStatus[resultStatus] }, void 0) }), void 0), isScreeningPassed && interviewDate && ((0, jsx_runtime_1.jsx)(__1.TitleWithContent, __assign({ title: "\uBA74\uC811 \uC77C\uC2DC", isLineThrough: confirmationStatus === types_1.ApplicationConfirmationStatusInDto.FINAL_CONFIRM_REJECTED }, { children: (0, date_1.formatDate)(interviewDate, 'YYYY년 M월 D일(ddd) a hh시 mm분') }), void 0)), (0, jsx_runtime_1.jsx)(Styled.ButtonContainer, { children: (0, jsx_runtime_1.jsx)(components_1.Button, { "$size": Button_component_1.ButtonSize.sm, shape: Button_component_1.ButtonShape.primaryLine, label: "\uC218\uC815", onClick: handleToggleIsEdit }, void 0) }, void 0)] }, void 0));
};
var ApplicationPanel = function (_a) {
    var confirmationStatus = _a.confirmationStatus, resultStatus = _a.resultStatus, interviewDate = _a.interviewDate, applicationId = _a.applicationId, restProps = __rest(_a, ["confirmationStatus", "resultStatus", "interviewDate", "applicationId"]);
    var state = (0, react_router_dom_1.useLocation)().state;
    var handleAddToast = (0, hooks_1.useToast)().handleAddToast;
    var methods = (0, react_hook_form_1.useForm)({
        defaultValues: {
            applicationResultStatus: resultStatus,
            interviewStartedAt: interviewDate
                ? (0, dayjs_1.default)(interviewDate).format()
                : (0, dayjs_1.default)().add(1, 'd').hour(8).minute(0).second(0).format(),
            isEdit: false,
        },
    });
    var _b = __read((0, react_2.useState)(false), 2), isLoading = _b[0], setIsLoading = _b[1];
    var handleSubmit = methods.handleSubmit;
    var handleSubmitUpdateResult = (0, recoil_1.useRecoilCallback)(function (_a) {
        var refresh = _a.refresh;
        return function (_a) {
            var applicationResultStatus = _a.applicationResultStatus, interviewStartedAt = _a.interviewStartedAt;
            return __awaiter(void 0, void 0, void 0, function () {
                var requestDto;
                return __generator(this, function (_b) {
                    requestDto = {
                        applicationResultStatus: applicationResultStatus,
                        interviewStartedAt: (0, date_1.toUtcFormat)(interviewStartedAt),
                        interviewEndedAt: (0, date_1.toUtcFormat)((0, dayjs_1.default)(interviewStartedAt).add(49, 'm').add(59, 's').format()),
                        applicationId: applicationId,
                    };
                    if (applicationResultStatus !== types_1.ApplicationResultStatusInDto.SCREENING_PASSED) {
                        delete requestDto.interviewStartedAt;
                        delete requestDto.interviewEndedAt;
                    }
                    (0, utils_1.request)({
                        requestFunc: function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        setIsLoading(true);
                                        return [4 /*yield*/, api.postUpdateResult(requestDto)];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); },
                        errorHandler: handleAddToast,
                        onSuccess: function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, refresh((0, store_1.$applicationById)({ applicationId: applicationId }))];
                                    case 1:
                                        _a.sent();
                                        return [4 /*yield*/, refresh((0, store_1.$applications)(state))];
                                    case 2:
                                        _a.sent();
                                        methods.setValue('isEdit', false);
                                        handleAddToast({
                                            type: styles_1.ToastType.success,
                                            message: '성공적으로 합격 여부가 변경되었습니다.',
                                        });
                                        return [2 /*return*/];
                                }
                            });
                        }); },
                        onCompleted: function () { return setIsLoading(false); },
                    });
                    return [2 /*return*/];
                });
            });
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)(react_hook_form_1.FormProvider, __assign({}, methods, { children: (0, jsx_runtime_1.jsxs)(Styled.ApplicationPanelContainer, { children: [(0, jsx_runtime_1.jsx)("h3", { children: "\uC791\uC131 \uBC0F \uC218\uC815\uC815\uBCF4" }, void 0), (0, jsx_runtime_1.jsxs)(Styled.ApplicationStatusForm, __assign({ onSubmit: handleSubmit(handleSubmitUpdateResult) }, { children: [(0, jsx_runtime_1.jsx)(__1.TitleWithContent, __assign({ title: "\uC0AC\uC6A9\uC790 \uD655\uC778 \uC5EC\uBD80" }, { children: (0, jsx_runtime_1.jsx)(ApplicationStatusBadge_component_1.default, { text: ApplicationStatusBadge_component_1.ApplicationConfirmationStatus[confirmationStatus] }, void 0) }), void 0), (0, jsx_runtime_1.jsx)(Styled.Divider, {}, void 0), (0, jsx_runtime_1.jsx)(ControlArea, __assign({ confirmationStatus: confirmationStatus, resultStatus: resultStatus, interviewDate: interviewDate, isLoading: isLoading }, restProps), void 0)] }), void 0)] }, void 0) }), void 0));
};
exports.default = ApplicationPanel;
